<template>
    <div class="agent pt20 pl30 col666">
        <div class="searchbox flex f-between padding20">
            <div></div>
            <div class="flex f-align-center">
                <p class="f14 mr10">集团名称：</p>
                <div class="inputbox">
                    <el-input v-model="groupName" placeholder="请输入集团名称"></el-input>
                </div>
                <a href="javascript:;" @click="searchGroup" class="searchbtn w100 text-center bg-green white ml15 f14">搜索</a>
            </div>
        </div>
        <p class="f14">已分配激活码：<span class="green">{{totalCode}}</span>个 已分配屏幕：<span class="green">{{totalScreen}}</span>个</p>
        <div class="mb15 mt15 mr30">
            <template>
                <el-table :data="tableData" border slot="empty">
                    <el-table-column prop="groupName" label="集团名称">
                    </el-table-column>
                    <el-table-column prop="agentName" label="所属经销商">
                    </el-table-column>
                    <el-table-column prop="allCodeNum" label="已分配激活码">
                        <!-- <template slot-scope="scope">
                            <div class="cur-p" @click="agentDetailCode(scope,1)">
                                {{scope.row.allCodeNum}}
                                <i class="el-icon-view green"></i>
                            </div>
                        </template> -->
                    </el-table-column>
                    <el-table-column prop="activeCodeNum" label="已用激活码">
                    </el-table-column>
                    <el-table-column prop="allScreen" label="已分配屏幕">
                        <template slot-scope="scope">
                            <div class="">
                                {{scope.row.allScreen}}
                                <i class="el-icon-view green cur-p" @click="agentDetailCode(scope.row,2)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activeScreen" label="已经绑定">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <p class="green cur-p" @click="giveScreen(scope.row)">分配屏幕</p>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div v-if="page.totalcount > 10">
                <template>
                    <div class="block pt20 text-right">
                        <el-pagination @current-change="grouplist" :current-page="page.pageno" :page-size="page.pagesize" layout="total, prev, pager, next, jumper"
                                       :total="page.totalcount">
                        </el-pagination>
                    </div>
                </template>
            </div>
        </div>
        <el-dialog :title="agentTitle" :visible.sync="allCodePage" :closeOnClickModal="false" @close="closeAllCodePage">
            <p>集团名称：<span class="green">{{currentBusinessName}}</span></p>
            <div class="mb15 mt15">
                <template>
                    <el-table :data="agentDetail" border slot="empty">
                        <el-table-column prop="allCodeNum" label="分配数量">
                        </el-table-column>
                        <el-table-column prop="activeCodeNum" label="已使用">
                        </el-table-column>
                        <el-table-column prop="time" label="分配时间">
                        </el-table-column>
                        <el-table-column prop="remark" label="备注">
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <p class="cur-p green" @click="usedCodeDetail(scope.row)">查看详情</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <div v-if="agentPage.totalcount > 10">
                    <template>
                        <div class="block pt20 text-right">
                            <el-pagination @current-change="propsorderlist" :current-page="agentPage.pageno" :page-size="agentPage.pagesize" layout="total, prev, pager, next, jumper"
                                           :total="agentPage.totalcount">
                            </el-pagination>
                        </div>
                    </template>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="查看激活码" :visible.sync="agentCodeDetail" :closeOnClickModal="false" @close="closeAgentCodeDetail">
            <p v-if="detailType == 1">旗舰版1年激活码：<span class="green">100个</span> 分配时间：<span class="green">2018-08-16</span></p>
            <p v-if="detailType == 2">全部屏幕：<span class="green">{{currentNum}}个</span> 分配时间：<span class="green">{{currentTime}}</span></p>            
            <!-- <div class="">
                <el-menu default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect"  active-text-color="#18C3B1">
                    <el-menu-item index="1">全部</el-menu-item>
                    <el-menu-item index="2">已使用</el-menu-item>
                    <el-menu-item index="3">未使用</el-menu-item>
                </el-menu>
            </div> -->
            <div class="mb15 mt15">
                <div v-if="detailType == 1">
                    <template>
                        <el-table :data="codeDetail" border slot="empty">
                            <el-table-column prop="" label="序号">
                            </el-table-column>
                            <el-table-column prop="" label="激活码">
                            </el-table-column>
                            <el-table-column prop="" label="使用状态">
                            </el-table-column>
                            <el-table-column prop="" label="使用门店">
                            </el-table-column>
                            <el-table-column label="开始使用时间">
                            </el-table-column>
                            <el-table-column label="到期时间">
                            </el-table-column>
                        </el-table>
                    </template>
                </div>
                <div v-if="detailType == 2">
                    <el-table :data="screenDetail" border slot="empty">
                        <el-table-column prop="mac" label="Mac地址">
                        </el-table-column>
                        <el-table-column prop="status" label="使用状态">
                        </el-table-column>
                        <el-table-column prop="store" label="使用门店">
                        </el-table-column>
                        <el-table-column prop="address" label="放置位置">
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="agentCodePage.totalcount > 10">
                    <template>
                        <div class="block pt20 text-right">
                            <el-pagination @current-change="propsorderdetaillist" :current-page="agentCodePage.pageno" :page-size="agentCodePage.pagesize" layout="total, prev, pager, next, jumper"
                                           :total="agentCodePage.totalcount">
                            </el-pagination>
                        </div>
                    </template>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="分配屏幕" :visible.sync="screenNum" :closeOnClickModal="false" @close="closeAllCodePage">
            <p>给“<span class="green">{{currentName}}</span>”分配屏幕</p>
            <div class="mb15 tabBox">
                <template>
                    <el-table :data="screenNumDetail" border slot="empty" @select="selectFn" @select-all="selectFn">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column prop="MacAddress" label="Mac地址">
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <p>备注：</p>
            <el-input type="textarea" placeholder="备注" v-model="giveRemark"></el-input>
            <div class="text-center mt15">
                <p>分配屏幕数量：<span class="red">{{pids.length}}个</span></p>
                <a href="javascript:;" class="searchbtn w100 text-center bg-green white ml15 f14 mt10" @click="bindingmerchants">确 定</a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                totalCode:0,
                totalScreen:0,
                groupName: '',
                tableData: [],
                page: {},
                allCodePage: false,
                agentDetail: [],
                agentPage: {},
                agentCodeDetail: false,
                agentCodePage: {},
                codeDetail: [],
                agentTitle: '',
                codeTitle: '',
                detailType: 1,
                screenDetail: [],
                screenNum: false,
                screenNumDetail: [],
                pids: [],
                giveRemark: '',
                currentBid: 0,
                currentName: '',
                currentBusinessid: 0,
                currentPoid: 0,
                currentBusinessName: '',
                currentTime: '',
                currentNum: 0,
            }
        },
        created() {
            var that = this;
            that.grouplist(1);
            // that.getrolloutpropsnum()
        },
        methods: {
            agentDetailCode(val, type) {
                var that = this;
                that.allCodePage = true;
                if(type == 1) {
                    that.agentTitle = '查看已分配激活码';
                    that.detailType = 1;
                } else {
                    that.agentTitle = '查看已分配屏幕';
                    that.detailType = 2;
                    that.currentBusinessid = val.bid;
                    that.currentBusinessName = val.groupName;
                    that.propsordertootherslist(1);
                }
            },
            closeAllCodePage() {
                var that = this;
                that.allCodePage = false;
            },
            usedCodeDetail(val) {
                var that = this;
                that.allCodePage = false;
                that.agentCodeDetail = true;
                that.currentPoid = val.poid;
                that.currentTime = val.time;
                that.currentNum = val.allCodeNum;
                that.propsorderdetaillist(1);
            },
            closeAgentCodeDetail() {
                var that = this;
                that.agentCodeDetail = false;
                that.codeDetail = [];
                that.allCodePage = true;
            },
            handleSelect(val) {
                var that = this;
                console.log(val)
            },
            giveScreen(val) {
                var that = this;
                that.listsbyowner(1);
                that.screenNum = true;
                that.currentBid = val.bid;
                that.currentName = val.groupName;
            },
            listsbyowner(page) {
                var that = this;
                var req = {
                    owner: that.accountutil.getAgent().agentid,
                    typeid: 1000,
                    ownertype: 200,
                    page: {
                        pageno: page,
                        pagesize: 9999
                    }
                }
                that.screenNumDetail = [];
                that.httputil.post({
                    that: that,
                    url: that.api.listsbyowner,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsinfo) {
                            for (var i = 0; i < res.propsinfo.length; i++) {
                                var target = res.propsinfo[i];
                                var json = {
                                    pid: target.pid,
                                    MacAddress: target.sncode,
                                }
                                that.screenNumDetail.push(json)
                            }
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            searchGroup() {
                var that = this;

                if(that.groupName) {
                    that.doSearchGroup();
                } else {
                    that.grouplist(1);
                }
            },
            doSearchGroup() {
                var that = this;

                var req = {
                    agentid: that.accountutil.getAgent().agentid,
                    type: 300,
                    name: that.groupName,
                    page: {
                        pageno: 1,
                        pagesize: 9999
                    }
                };

                that.tableData = [];

                that.httputil.post({
                    that: that,
                    url: that.api.agentsearch,
                    req: req,
                    xmsuccess: function (res) {
                        that.tableData = (res.list || []).map(function (val, index, array) {
                            return {
                                bid: val.agentsub.brand.bid,
                                allCodeNum: val.totaltransfercode ? val.totaltransfercode : 0,
                                activeCodeNum: val.totalhasusecode ? val.totalhasusecode : 0,
                                allScreen: val.totaltransferprops ? val.totaltransferprops : 0,
                                activeScreen: val.totalhasuseprops ? val.totalhasuseprops : 0,
                                groupName: val.agentsub.brand.name,
                            }
                        });
                        if(res.ownertransfercode){
                            that.totalCode = res.ownertransfercode
                        }
                        if(res.ownertransferprops){
                            that.totalScreen = res.ownertransferprops
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            selectFn(selection) {
                var that = this;
                var pid = [];
                if(selection.length > 0) {
                    for (let i = 0; i < selection.length; i++) {
                        pid.push(selection[i].pid)
                    }
                }
                that.pids = pid
            },
            grouplist(page) {
                let that = this;
                let req = {
                    agentid: that.accountutil.getAgent().agentid,
                    type: 300,
                    page: {
                        pageno: page,
                        pagesize: 10
                    }
                }
                that.tableData = []
                that.httputil.post({
                    that: that,
                    url: that.api.grouplist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.list) {
                            for (let val of res.list) {
                                let json = {
                                    bid: val.agentsub.brand.bid,
                                    agentName: val.agentsub.name,
                                    allCodeNum: val.totaltransfercode ? val.totaltransfercode : 0,
                                    activeCodeNum: val.totalhasusecode ? val.totalhasusecode : 0,
                                    allScreen: val.totaltransferprops ? val.totaltransferprops : 0,
                                    activeScreen: val.totalhasuseprops ? val.totalhasuseprops : 0,
                                    groupName: val.agentsub.brand.name,

                                }
                                that.tableData.push(json)
                            }
                        }
                        if(res.ownertransfercode){
                            that.totalCode = res.ownertransfercode
                        }
                        if(res.ownertransferprops){
                            that.totalScreen = res.ownertransferprops
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            //分配屏幕
            bindingmerchants() {
                var that = this;
                if(that.pids.length == 0) {
                    that.$message({
                        message: '请至少选择一个设备！',
                        type: 'warning'
                    });
                    return;
                }
                var req = {
                    receiver: that.currentBid,
                    receivertype: 300,
                    pidlist: that.pids,
                    remark: that.giveRemark
                }
                that.httputil.post({
                    that: that,
                    url: that.api.bindingmerchants,
                    req: req,
                    xmsuccess: function (res) {
                        that.$message({
                            message: '分配成功！',
                            type: 'success'
                        });
                        that.pids = [];
                        that.screenNum = false;
                        that.grouplist(1);
                        that.giveRemark = '';
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            propsordertootherslist(page){
                let that = this;
                let req = {
                    type:1000,
                    fromtype:200,
                    fromid:that.accountutil.getAgent().agentid,
                    totype:300,
                    toid:that.currentAgentId,
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                }
                that.agentDetail = [];
                that.httputil.post({
                    that: that,
                    url: that.api.propsordertootherslist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsorder) {
                            for (let val of res.propsorder) {
                                let param = {
                                    poid: val.poid,
                                    success(num) {
                                        let json = {
                                            poid: val.poid,
                                            allCodeNum: val.num,
                                            activeCodeNum: num,
                                            remark: val.remark,
                                            time: new Date(val.createtime * 1000).format("yyyy/MM/dd HH:mm:ss")
                                        }
                                        that.agentDetail.push(json)
                                    }
                                }
                                that.getusedcountbypoid(param);
                            }
                        }
                        that.agentPage = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            propsorderlist(page) {
                var that = this;
                var req = {
                    searchtype: 1,
                    type: 1000,
                    businesstype: 300, // 权限控制
                    businessid: that.currentBusinessid, //集团、经销商id
                    page: {
                        pageno: page,
                        pagesize: 10
                    }
                }
                that.agentDetail = [];
                that.httputil.post({
                    that: that,
                    url: that.api.propsorderlist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsorder) {
                            for (let val of res.propsorder) {
                                let param = {
                                    poid: val.poid,
                                    success(num) {
                                        let json = {
                                            poid: val.poid,
                                            allCodeNum: val.num,
                                            activeCodeNum: num,
                                            remark: val.remark,
                                            time: new Date(val.createtime * 1000).format("yyyy/MM/dd HH:mm:ss")
                                        }
                                        that.agentDetail.push(json)
                                    }
                                }
                                that.getusedcountbypoid(param);
                            }
                        }
                        that.agentPage = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            getusedcountbypoid(param) {
                let that = this;
                let req = {
                    poid: param.poid,
                    usestatus: 101
                }
                that.httputil.post({
                    that: that,
                    url: that.api.getusedcountbypoid,
                    req: req,
                    xmsuccess: function (res) {
                        if(param) {
                            param.success(parseInt(res.num || "0"));
                        }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            propsorderdetaillist(page) {
                var that = this;
                var req = {
                    searchtype: 1,
                    poid: that.currentPoid,
                    businesstype: 300,
                    businessid: that.currentBusinessid,
                    page: {
                        pageno: page,
                        pagesize: 10
                    }
                }
                that.screenDetail = [];
                that.httputil.post({
                    that: that,
                    url: that.api.propsorderdetaillist,
                    req: req,
                    xmsuccess: function (res) {
                        that.agentCodePage = res.page || {}
                        if(res.propsorderdetail){
                            for(let val of res.propsorderdetail){
                                let json = {
                                    mac:val.props.sncode,
                                    status:val.props.usestatus == 100?'未使用':'已使用',
                                    store:val.props.store?val.props.store.name:'--',
                                    address:val.props.address?val.props.address:'--'
                                }
                                that.screenDetail.push(json)
                            }
                        }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            getrolloutpropsnum(){
                let that = this;
                let req = {
                    businesstype:that.accountutil.isGroup()?300:200,
                    businessid:that.accountutil.isGroup()?that.accountutil.getBid():that.accountutil.getAgent().agentid,
                }
                that.httputil.post({
                    that: that,
                    url: that.api.getrolloutpropsnum,
                    req: req,
                    xmsuccess: function (res) {
                       if(res.rolloutpropsnum){
                           that.totalScreen = res.rolloutpropsnum
                       }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
        }
    }
</script>
<style scoped>
    .searchbox {
        height: 40px;
    }

    .inputbox {
        width: 180px;
    }

    .searchbtn {
        border-radius: 10px;
        height: 35px;
        line-height: 35px;
        display: inline-block;
    }

    .tabBox {
        max-height: 350px;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// src/pages/group.vue